import React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import './coursePack.module.scss';
import PatternLeft from './images/pattern-left-pink.png';
import PatternRight from './images/pattern-right-pink.png';
import SheHirameki from './images/she-hirameki.png';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import classNames from 'classnames';
import RoleModelCard1 from './images/shares-4931024.png';
import RoleModelCard2 from './images/shares-4930420.png';
import {
  CourseMarketingFirstCard,
  CourseSmallAdvertisingOperationCard,
  CourseSmallBrandingCard,
  CourseSmallCopyWritingCard,
  CourseSmallPrCard,
  CourseSmallSelfBrandingCard,
  CourseWebMarketingCard,
} from './CourseCard';
import { V3Routes } from '../../routes';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

@withNavigation(NavigationSpecs.side())
@authenticated
export class MarketerPage extends React.Component {
  render() {
    const breadCrumbItems = [{ text: 'コース', to: V3Routes.courses() }, { text: 'マーケターセット' }];
    return (
      <>
        <div styleName={classNames('head', 'marketer')}>
          <div styleName="head-inner">
            <BreadCrumb items={breadCrumbItems} hasHome />
            <div styleName="head-content">
              <div styleName={classNames('course-title', 'marketer')}>マーケターセット</div>
              <div styleName="head-detail">
                <div styleName="description">
                  製品やサービスを必要とする人に正しく届けるための戦略づくりであるマーケティングの基礎知識から、実例を元にマーケティング思考を身につけていくセットです。基礎を身につけた後は周辺領域のスキルを掛け合わせて学びを広げていき、社内外で通用するWebマーケターや、マーケティング周辺職種に転身していく方もいらっしゃいます。
                </div>
                <div styleName={classNames('comment', 'marketer')}>
                  <div styleName="label-box">
                    <div styleName={classNames('label', 'marketer')}>こんなひとにおすすめ</div>
                  </div>
                  <img src={SheHirameki} styleName="she-image" />
                  <ul styleName="comment-text">
                    <li>マーケティングを仕事にしたい</li>
                    <li>モノやサービスを世に広げていきたい</li>
                    <li>選ばれるブランドづくりに携わりたい</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName={classNames('content-bg', 'marketer')}>
          <div styleName="content">
            <p styleName="title">必修コース</p>
            <p styleName="sub-title">必ず受けておきたいコース</p>
            <div styleName="main-course-list">
              <CourseMarketingFirstCard />
              <CourseWebMarketingCard />
            </div>
            <div styleName="title">選択コース</div>
            <div styleName="sub-title">なりたい姿に合わせて追加で受けておきたいコース</div>
            <div styleName="pattern-bg">
              <img src={PatternLeft} styleName="pattern-left" />
              <img src={PatternRight} styleName="pattern-right" />
              <div styleName="pattern">
                <div styleName={classNames('label', 'marketer')}>先輩シーメイトたちの受講パターン</div>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'marketer')}>パターン1</span>
                <span styleName="pattern-text">
                  ブランドの一貫した世界観を、あらゆる方法で届けるためのスキルをつけたい
                </span>
              </div>
              <div styleName="pattern-intro">
                <span styleName={classNames('marker', 'marketer')}>パターン2</span>
                <span styleName="pattern-text">Webマーケターとして活躍していくための、周辺スキルを一気に学びたい</span>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン1</p>
              {GlobalStatesV3.viewport.isMobile && (
                <p styleName={classNames('pattern-label', 'marketer')}>
                  ブランドの一貫した世界観を、あらゆる方法で届けるためのスキルをつけたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isDesktop && (
                  <p styleName={classNames('pattern-label', 'marketer')}>
                    ブランドの一貫した世界観を、あらゆる方法で届けるためのスキルをつけたい
                  </p>
                )}
                <p styleName="description sp-space">
                  マーケティングとブランディングの知識を掛け合わせ「お客様から選ばれるブランドをどうやって築いていけばよいか」「どうすれば届けたい人に届くか」を学ぶセットです。マーケティングの基礎知識をベースに、自社のサービスや自分のブランドの価値を高めたり、企業の商品やサービスを誰かに選ばれるブランドに育てていったりしたい方におすすめです。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallBrandingCard />
                      <CourseSmallSelfBrandingCard />
                      <CourseSmallCopyWritingCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4931024" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard1} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div styleName="pattern-box">
              <p styleName="pattern-num">パターン2</p>
              {GlobalStatesV3.viewport.isMobile && (
                <p styleName={classNames('pattern-label', 'marketer')}>
                  Webマーケターとして活躍していくための、周辺スキルを一気に学びたい
                </p>
              )}
              <div styleName="pattern-detail-box">
                {GlobalStatesV3.viewport.isDesktop && (
                  <p styleName={classNames('pattern-label', 'marketer')}>
                    Webマーケターとして活躍していくための、周辺スキルを一気に学びたい
                  </p>
                )}
                <p styleName="description sp-space">
                  Webマーケターとして活躍するための周辺スキルを一気に身につけられるセットです。マーケティングの基礎から応用までを学び、未経験からでも、現場で活躍できるマーケターとしてのキャリアをスタートさせたい方へおすすめです。
                </p>
                <div styleName="intro-images">
                  <div>
                    <div styleName="sp-space">
                      <div styleName="pattern-title">COURSES</div>
                      <div styleName="sub-title">おすすめ受講コース</div>
                    </div>
                    <div styleName="small-course-area">
                      <CourseSmallAdvertisingOperationCard />
                      <CourseSmallPrCard />
                    </div>
                  </div>
                  <div styleName="sp-space">
                    <div styleName="pattern-title">ROLE MODEL STORIES</div>
                    <div styleName="sub-title">先輩シーメイトインタビュー</div>
                    <div styleName="role-model-img">
                      <a href="https://shelikes.jp/shares/posts/4930420" target="_blank">
                        <img styleName="role-model-card" src={RoleModelCard2} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
